export default "/kiban/_next/static/images/myPageIcon-ffce0c4f28af6503fc6415922aa3dd8f.png";